import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PasswordRequirementsComponent } from './password-requirements.component';

@NgModule({
  declarations: [PasswordRequirementsComponent],
  imports: [CommonModule],
  exports: [PasswordRequirementsComponent]
})
export class PasswordRequirementsModule {}
